export const MAP_SNACKBAR_TTL = 14 * 86400000;
export const MAP_SNACKBAR_EXPIRY_KEY = 'kyruus_pin_assist';

// tracking events
export const CLICK_LOCATION_DETAILS = 'user_action.click_locations_details';
export const CTA_SHOW_MAP_VIEW = 'user_action.show.map_view';
export const CTA_SEARCH_THIS_AREA = 'user_action.cta.search_this_area';
export const CLICK_CLOSE_PROVIDER_DRAWER =
  'user_action.close.provider_drawer_on_map';
export const CLICK_LOAD_MORE_PROVIDERS =
  'user_action.load_more_search_results_in_map';
export const OPEN_MAPS_FILTER_DRAWER =
  'user_action.show.filter_drawer_on_map';
export const CLICK_BACK_TO_LIST_VIEW_BUTTON =
  'user_action.click_back_to_list_from_map_view';
export const NO_SORT_FILTER_BANNER = 'user_action.page_view.filters_no_results';
export const MAPS_PROVIDER_DRAWER_NO_RESULT = 'user_action.page_view.map_no_results';
export const MAPS_PROVIDER_DRAWER_LOADING_ERROR = 'user_action.page_view.map_failed_to_load';
export const CLICK_MAP_LOCATION_PIN = 'user_action.map.pin_click';
export const MAP_ZOOM_IN = 'user_action.map.zoom_in';
export const MAP_ZOOM_OUT = 'user_action.map.zoom_out';
export const HIDE_HOW_TO_PIN = 'user_action.hide.how_to_pin';
export const CLICK_MAPS_PROVIDER_TILE = 'user_action.provider_tile_in_map_view';
export const CLICK_MAPS_PROVIDER_TILE_BOOK_APPT = 'user_action.book_appt_click_in_map_view';
export const CLICK_MAPS_SWIPE_TO_VIEW_PROVIDERS = 'user_action.swipe_view_providers';
